/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var Vue = _interopDefault(require('vue'));
var assert = require('../util/assert');

var Interaction = __ol__.interaction.Interaction;
var methods = {
  /**
   * @return {IndexedCollectionAdapter}
   * @protected
   */
  getInteractionsTarget: function getInteractionsTarget() {
    throw new Error('Not implemented method');
  },

  /**
   * @param {ol.interaction.Interaction|Vue} interaction
   * @return {void}
   */
  addInteraction: function addInteraction(interaction) {
    interaction = interaction instanceof Vue ? interaction.$interaction : interaction;
    assert.instanceOf(interaction, Interaction);

    if (this.getInteractionsTarget().has(interaction) === false) {
      this.getInteractionsTarget().add(interaction);
      this.sortInteractions();
    }
  },

  /**
   * @param {ol.interaction.Interaction|Vue} interaction
   * @return {void}
   */
  removeInteraction: function removeInteraction(interaction) {
    interaction = interaction instanceof Vue ? interaction.$interaction : interaction;

    if (!interaction) return;

    if (this.getInteractionsTarget().has(interaction)) {
      this.getInteractionsTarget().remove(interaction);
      this.sortInteractions();
    }
  },

  /**
   * @return {ol.interaction.Interaction[]}
   */
  getInteractions: function getInteractions() {
    return this.getInteractionsTarget().elements;
  },

  /**
   * @param {string|number} id
   * @return {ol.interaction.Interaction|undefined}
   */
  getInteractionById: function getInteractionById(id) {
    return this.getInteractionsTarget().findByKey(id);
  },

  /**
   * @return {void}
   */
  sortInteractions: function sortInteractions(sorter) {
    sorter || (sorter = this.getDefaultInteractionsSorter());
    this.getInteractionsTarget().sort(sorter);
  },

  /**
   * @return {function}
   * @protected
   */
  getDefaultInteractionsSorter: function getDefaultInteractionsSorter() {
    return function () {
      return 0;
    };
  },

  /**
   * @return {void}
   */
  clearInteractions: function clearInteractions() {
    this.getInteractionsTarget().clear();
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return {
      get interactionsContainer() {
        return vm;
      }
    };
  }
};

var interactionsContainer = {
  methods: methods,
  destroyed: function destroyed() {
    this.clearInteractions();
  }
};

module.exports = interactionsContainer;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/interactions-container.js
// module id = 517
// module chunks = 1